import { SlimHero, SlimHeroBlock } from "components/HeroBlocks/SlimHero";
import { HorizontalNavBar } from "components/NavBar/HorizontalNavBar";
import { NavBarBlock, NavBarCmsData } from "components/NavBar/interfaces";

import { SplitLayoutSubPage } from "./SplitLayoutSubPage";
import { Toolbox, ToolboxBlock } from "./Toolbox";

export type MultiLayoutBody = Array<ToolboxBlock | NavBarBlock | SlimHeroBlock>;

export interface MultiLayoutCmsData<SplitBodyBlock = ToolboxBlock> {
    body: MultiLayoutBody;
    split_layout_body: Array<SplitBodyBlock>;
    split_layout_nav: NavBarCmsData | null;
}

export interface MultiLayoutProps
    extends Omit<MultiLayoutCmsData, "split_layout_body"> {
    children: React.ReactNode;
    classNameSplitLayout?: string;
}

export const MultiLayoutSubPage = ({
    body,
    children,
    split_layout_nav,
    classNameSplitLayout,
}: MultiLayoutProps) => (
    <>
        {body.map((block, index) => {
            switch (block.type) {
                case "slim_hero":
                    return <SlimHero key={block.id} cmsData={block.value} />;
                case "nav_bar":
                    return (
                        <HorizontalNavBar
                            key={block.id}
                            cmsData={block.value}
                        />
                    );
                default:
                    return (
                        <Toolbox
                            block={block}
                            key={block.id}
                            isFirstBlock={index === 0}
                        />
                    );
            }
        })}
        <SplitLayoutSubPage
            nav={split_layout_nav}
            hasLayoutAbove={body.length > 0}
            className={classNameSplitLayout}
        >
            {children}
        </SplitLayoutSubPage>
    </>
);
